import { combineReducers } from 'redux';
import OrderPaymentReducer from './OrderPayment/OrderPaymentReducer';
import DonationReducer from './Donation/DonationReducer';

export default combineReducers({
	orders: OrderPaymentReducer,
	donations: DonationReducer,
});
